/**
* Location Callout JS
* -----------------------------------------------------------------------------
*
* All the JS for the Location Callout component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'location-callout',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );
      const rotate = gsap.timeline( {
        scrollTrigger: {
          trigger: '.wheel-wrapper',
          scrub: 1,
          start: 'top bottom',
          end: 'bottom top',
        },
      } )
          .to( '.inner', {
            rotation: 180,
            duration: 1, ease: 'none',
          } );

      $( '.location-callout' ).each( function() {
        ScrollTrigger.create( {
          trigger: this,
          start: 'top 25%',
          scrub: 0.15,
          onRefresh: ( self ) => {
            if ( self.progress > 0 ) {
              $( this ).addClass( 'active' );
            }
          },
          onEnter: ( {progress, direction, isActive} ) => $( this ).addClass( 'active' ),
        } );
      } );

      // FIND VIEWER HEIGHT AND ADJUST CONTENT LOCATION OVER IMAGE ACCORDINGLY
      const vh = $( window ).height();
      console.log( vh );
      if ( vh > 840 ) {
        $( '.location-callout__content' ).css( 'top', '42%' );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'location-callout', COMPONENT );
} )( app );
